export default function getBreakpoint(){return window.getComputedStyle(document.body,":after").content.replace(/"/g,"")}